import React from 'react';
import { ClipboardList, Mail } from 'lucide-react';
import { FEEDBACK_LINK_VALIDITY_LABEL } from '../utils/feedbackLinkValidity';

export default function InterviewerFeedbackChoiceModal({
  open,
  busy,
  error,
  onGiveNow,
  onGiveLater,
}) {
  if (!open) return null;

  return (
    <div
      className="li-modal-overlay li-feedback-choice-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="interviewer-feedback-choice-title"
    >
      <div className="li-feedback-choice-card" onClick={(e) => e.stopPropagation()}>
        <p className="li-feedback-eyebrow">Post-interview</p>
        <h3 className="li-feedback-title" id="interviewer-feedback-choice-title">
          Share interviewer feedback
        </h3>
        <p className="li-feedback-sub">
          The meeting has ended. Choose how you would like to provide feedback. We can email you a
          secure feedback link, valid for {FEEDBACK_LINK_VALIDITY_LABEL}, if you prefer to complete it later.
        </p>
        {error ? <div className="li-modal-error">{error}</div> : null}
        <div className="li-feedback-choice-actions">
          <button
            type="button"
            className="li-feedback-choice-btn is-primary"
            onClick={onGiveNow}
            disabled={busy}
          >
            <ClipboardList size={18} aria-hidden />
            <span>
              <strong>Give feedback now</strong>
              <small>~5 min voice-guided session</small>
            </span>
          </button>
          <button
            type="button"
            className="li-feedback-choice-btn"
            onClick={onGiveLater}
            disabled={busy}
          >
            <Mail size={18} aria-hidden />
            <span>
              <strong>Give feedback later</strong>
              <small>We will email you a secure link valid for {FEEDBACK_LINK_VALIDITY_LABEL}</small>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}
